// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1uZ_V","info":"PatientInfo_info__2uUVK"};